<template>
  <div class="container">
    <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/tg_title_01.png" alt="" class="title" />
    <div class="content">
      <div class="hint-box">
        <h3>友情提示</h3>
        <ul>
          <li>1.学历：须具备中等专科以上学历方可获得报考资格， 部分省份非中专及以上学历也可以报考！</li>
          <li>2.专业：工程及工程经济类专业。部分省份，非本专 业满足一定的工作年限也有机会报考！</li>
          <li>3.工作年限：从事建设工程项目施工管理工作满2年， 工作年限计算截止日期为考试当年年底！</li>
          <li>4.考生注意：各省二级建造师报考条件有差异，请<span style="color: #e70000">准确选择所在地区，输入正确手机号</span>接收查询结果！</li>
        </ul>
      </div>
      <div class="query-box">
        <h2>自助查询</h2>
        <div class="form-item">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/location_icon.png" alt="" />
          <span><i>*</i>所在地</span>
          <select v-model="province" :style="{ color: province.length ? '#000' : '#6A6A6A' }">
            <option value="" disable>请选择您所在的省份</option>
            <option value="河南省">河南省</option>
            <option value="北京市">北京市</option>
            <option value="天津市">天津市</option>
            <option value="河北省">河北省</option>
            <option value="山西省">山西省</option>
            <option value="内蒙古自治区">内蒙古自治区</option>
            <option value="辽宁省">辽宁省</option>
            <option value="吉林省">吉林省</option>
            <option value="黑龙江省">黑龙江省</option>
            <option value="上海市">上海市</option>
            <option value="江苏省">江苏省</option>
            <option value="浙江省">浙江省</option>
            <option value="安徽省">安徽省</option>
            <option value="福建省">福建省</option>
            <option value="江西省">江西省</option>
            <option value="山东省">山东省</option>
            <option value="湖北省">湖北省</option>
            <option value="湖南省">湖南省</option>
            <option value="广东省">广东省</option>
            <option value="广西壮族自治区">广西壮族自治区</option>
            <option value="海南省">海南省</option>
            <option value="重庆市">重庆市</option>
            <option value="四川省">四川省</option>
            <option value="贵州省">贵州省</option>
            <option value="云南省">云南省</option>
            <option value="西藏自治区">西藏自治区</option>
            <option value="陕西省">陕西省</option>
            <option value="甘肃省">甘肃省</option>
            <option value="青海省">青海省</option>
            <option value="宁夏回族自治区">宁夏回族自治区</option>
            <option value="新疆维吾尔自治区">新疆维吾尔自治区</option>
            <option value="台湾">台湾</option>
            <option value="香港">香港</option>
            <option value="澳门">澳门</option>
          </select>
          <div class="arrow"></div>
        </div>
        <div class="form-item">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/user_icon.png" alt="" />
          <span><i>*</i>姓<em style="font-style: inherit; visibility: hidden">姓</em>名</span>
          <input type="text" placeholder="请输入您的姓名" v-model="userName" maxlength="10" />
        </div>
        <div class="form-item">
          <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/tel_icon.png" alt="" />
          <span><i>*</i>手机号</span>
          <input placeholder="请输入您的手机号" v-model="phone" maxlength="11" />
        </div>
        <button @click="queryClick">点击查询</button>
        <div class="agree">
          <label>
            <input type="checkbox" v-model="isAgree" style="width: 15px; height: 15px" />
            <p>已阅读并接受《用户服务协议》和《隐私政策》</p>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5'
import { phoneValidator, isMobile } from '@/utils/index'
import { submitConsult } from '@/api/index.js'
export default {
  data() {
    return {
      province: '',
      userName: '',
      phone: '',
      isAgree: false,
      isLoading: false
    }
  },
  computed: {
    agreeUrl() {
      return isMobile()
        ? 'https://x.zhongke3.com/apis/coursera/common/rich/text/1/71d76ae3eb8e42ce9c5d8151fffc9192'
        : 'https://x.zhongke3.com/zj-wx-web-pc/login/protocol?type=1'
    },
    privacyUrl() {
      return isMobile()
        ? 'https://x.zhongke3.com/apis/coursera/common/rich/text/1/8a6eef758fb44d1db7f0a43834d33edd'
        : 'https://x.zhongke3.com/zj-wx-web-pc/login/protocol?type=2'
    }
  },
  methods: {
    queryClick() {
      if (!this.province.length) {
        return this.$toast.center('请选择您所在的省份')
      }
      if (!this.userName.length) {
        return this.$toast.center('请输入您的姓名')
      }
      if (!this.phone.length) {
        return this.$toast.center('请输入您的手机号')
      }
      if (!phoneValidator(this.phone)) {
        return this.$toast.center('请输入正确的手机号')
      }
      if (!this.isAgree) {
        return this.$toast.center('请勾选协议')
      }
      const gt = new Date().getTime().toString()
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      submitConsult({
        mobile: this.phone,
        name: this.userName,
        area: this.province,
        time: gt,
        encryPwd: md5(gt + 'verify')
      })
        .then(res => {
          if (res.code == 200) {
            this.$toast.center('提交成功')
            setTimeout(() => {
              this.province = ''
              this.userName = ''
              this.phone = ''
              this.isAgree = false
            }, 1000)
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  li {
    list-style: none;
  }
}
a {
  text-decoration: none;
}
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-image: url(https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/tg_bg01.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .title {
    padding-top: 87px;
    padding-bottom: 26px;
    text-align: center;
  }
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1534px;
    height: 722px;
    background: rgba(248, 248, 248, 0.78);
    box-shadow: 0px 3px 12px 0px rgba(255, 255, 255, 0.3);
    border-radius: 12px;
    .hint-box {
      width: 466px;
      margin-right: 56px;
      flex-shrink: 0;
      h3 {
        font-size: 27px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #302f30;
      }
      ul {
        li {
          margin-top: 20px;
          font-size: 21px;
          font-family: Microsoft YaHei;
          color: #302f30;
        }
      }
    }
    .query-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 0;
      width: 554px;
      height: 563px;
      background: linear-gradient(1deg, #b1def2, #e0e5f0, #fffffd, #dfe5f0);
      box-shadow: 0px 3px 4px 0px rgba(124, 128, 134, 0.52);
      border-radius: 20px;
      h2 {
        padding-top: 50px;
        font-size: 40px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2867cd;
      }
      .form-item {
        position: relative;
        display: flex;
        align-items: center;
        margin-top: 20px;
        img {
          width: 28px;
          height: 28px;
        }
        span {
          font-size: 22px;
          color: #898989;
          i {
            color: #ee2222;
            font-style: inherit;
          }
        }
        select,
        input {
          width: 318px;
          height: 57px;
          padding-left: 20px;
          margin-left: 15px;
          background: #ffffff;
          font-size: 18px;
          border: 1px solid #d9d9d9;
          box-sizing: border-box;
          border-radius: 6px;
          outline: none;
        }
        select {
          appearance: none;
          -moz-appearance: none;
          -webkit-appearance: none;
        }
        .arrow {
          position: absolute;
          top: 0;
          right: 0;
          width: 10px;
          height: 10px;
          margin-right: 16px;
          margin-top: 20px;
          transform: rotate(45deg);
          border-bottom: 1px solid #000;
          border-right: 1px solid #000;
        }
      }
      button {
        width: 450px;
        height: 56px;
        margin-top: 49px;
        font-size: 22px;
        color: #ffffff;
        background: linear-gradient(0deg, #0a6cff, #15b8fc);
        border-radius: 6px;
        outline: none;
        border: none;
        cursor: pointer;
      }
      .agree {
        label {
          display: flex;
          align-items: center;
          margin-top: 23px;
          cursor: pointer;
          input {
            margin: 0;
          }
          p {
            color: #868686;
            margin: 0 0 0 10px;
            a {
              color: #868686;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .container {
    background-size: auto;
    .title {
      width: 90%;
      padding: 30px 0px;
    }
    .content {
      flex-direction: column;
      width: 100%;
      height: auto;
      padding: 0 16px;
      box-sizing: border-box;
      background-size: cover;
      box-shadow: none;
      background: none;
      .query-box {
        width: 100%;
        height: 470px;
        background: none;
        box-shadow: none;
        zoom: 75%;
        order: 0;
        h2 {
          padding-top: 0;
        }
      }
      .hint-box {
        margin-top: 0;
        width: 100%;
        margin-right: 0;
        order: 1;
        h3 {
          font-size: 14px;
        }
        ul {
          li {
            margin-top: 5px;
            font-size: 12px;
          }
        }
      }
    }
  }
}

@media (min-width: 993px) and (max-width: 1280px) {
  .container {
    .title {
      padding: 30px 0px;
    }
    .content {
      width: 90%;
    }
    .query-box {
      zoom: 80%;
    }
  }
}

@media (min-width: 1281px) and (max-width: 1920px) {
  .container {
    .content {
      zoom: 92%;
    }
  }
}
</style>
